import Lenis from "lenis";

let lenis = null;

export function initLenis() {
    if (typeof window === "undefined") return null;
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced || lenis) return lenis;
    lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    const raf = (time) => {
        lenis.raf(time);
        requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
    return lenis;
}

export function scrollToTarget(target) {
    const el =
        typeof target === "string" ? document.querySelector(target) : target;
    if (!el) return;
    if (lenis) {
        lenis.scrollTo(el, { offset: -72, duration: 1.4 });
    } else {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
}

export function scrollToTop() {
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
}
